import { Grid, Box } from "@mui/material";
import { Title, ColoredTitle, SubTitle, StyledBox } from "./styles";

export default function Initial() {
  return (
    <StyledBox>
      <Grid
        pt={{ xs: "185px", sm: "185px", md: "200px", lg: "200px", xl: "200px" }}
        container
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid
          item
          xs={9}
          sm={9}
          md={9}
          lg={12}
          xl={12}
          px={1}
          pt={{ xs: 1.5, sm: 1.5, md: 2, lg: 6.5, xl: 6.5 }}
        >
          <Title>
          Ouvidoria: <ColoredTitle>sua voz importa </ColoredTitle>
          </Title>
        </Grid>
        <Grid
          item
          pt={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}
          xs={11}
          sm={8}
          md={7}
          lg={6.5}
          xl={6}
          px={{ xs: 0, sm: 0.5, md: 1, lg: 1.5, xl: 6 }}
        >
          <SubTitle>
            Na Itop Telecom, valorizamos a transparência e a comunicação aberta
            com nossos clientes. A Ouvidoria é um canal dedicado a receber suas
            opiniões, sugestões, elogios e reclamações, garantindo que sua voz
            seja ouvida e suas questões sejam tratadas de forma justa e eficaz.
          </SubTitle>
          <Box pt={{xs: 7, sm: 15, md: 15, lg: 15, xl: 15}} textAlign="center">
            <img
              src="/images/arrow.png"
              width={45}
              height={45}
              alt="arrow icon"
            />
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
}
